import { IconBell } from '@calendly/ui/components/glyphs/IconBell'
import { IconCalendarCheck } from '@calendly/ui/components/glyphs/IconCalendarCheck'
import { IconCreditCard } from '@calendly/ui/components/glyphs/IconCreditCard'
import { IconFileText } from '@calendly/ui/components/glyphs/IconFileText'
import { IconList } from '@calendly/ui/components/glyphs/IconList'

import {
  PANEL_KEYS_WITH_COMPONENTS,
  PANELS,
} from 'constants/event_type_editor_panels'

import { availabilityTabDefinition } from './availability/tab_config'
import { bookingPageTabDefinition } from './booking_page/tab_config'
import { schedulingLimitsTabDefinition } from './scheduling_limits/tab_config'

export const EVENT_TYPE_EDITOR_CRUD_GATE = 'sa_et_crud_single_host'
export const EVENT_TYPE_EDITOR_CRUD_GATE_TARGETING = {
  gate: EVENT_TYPE_EDITOR_CRUD_GATE,
  audiences: ['internal', 'pre-alpha']
}
export const DEFAULT_TAB_KEY = 'meeting-details'

const tabDefinitions = [
  {
    key: DEFAULT_TAB_KEY,
    label: 'Meeting details',
    icon: IconList,
    subtitle: 'Name, duration, location',
    formKey: 'eventDetails',
    panelKeys: [
      PANELS.duration,
      PANELS.location,
      PANELS.hosts,
      PANELS.assign,
      PANELS.groupEvent
    ]
  },
  availabilityTabDefinition,
  schedulingLimitsTabDefinition,
  bookingPageTabDefinition,
  {
    key: 'payments',
    label: 'Payments',
    icon: IconCreditCard,
    subtitle: 'Collect payment',
    formKey: 'moreOptions',
    panelKeys: [
      PANELS.payment
    ]
  },
  {
    key: 'notifications',
    label: 'Notifications',
    icon: IconBell,
    subtitle: 'Confirmations, reminders',
    formKey: 'moreOptions',
    panelKeys: [
      PANELS.notifications
    ]
  },
  {
    key: 'confirmation',
    label: 'Confirmations',
    icon: IconCalendarCheck,
    subtitle: 'Confirmation page',
    formKey: 'moreOptions',
    panelKeys: [
      PANELS.confirmationPage
    ]
  },
  {
    key: 'description',
    label: 'Description',
    icon: IconFileText,
    subtitle: 'Meeting description',
    formKey: 'moreOptions',
    panelKeys: [
      PANELS.description
    ]
  }
]

const buildTab = ({ panelKeys, ...tab }) => {
  const resolvedPanelKeys = panelKeys.filter((panelKey) => PANEL_KEYS_WITH_COMPONENTS.includes(panelKey))

  return {
    ...tab,
    panelKeys: resolvedPanelKeys
  }
}

export const eventTypeEditorCrudTabs = tabDefinitions.map(buildTab).filter(({ panelKeys }) => panelKeys.length > 0)

export const getEventTypeEditorCrudTab = (tabKey) => (
  eventTypeEditorCrudTabs.find(({ key }) => key === tabKey)
)

export const getDefaultEventTypeEditorCrudTab = () => (
  getEventTypeEditorCrudTab(DEFAULT_TAB_KEY)
)
